import { formatBytes } from '../../../utilities/format';

interface Props {
  type: string | undefined | null;
  bytes: number;
  files: number;
  testId?: string;
}

// Renders a `<td>` for a Collection's source/output: type chip, formatted size, file count.
export function IoCell({ type, bytes, files, testId }: Props) {
  return (
    <td data-testid={testId}>
      <span className="label label-default">{type || 'n/a'}</span>
      {' '}{formatBytes(bytes)} — {files.toLocaleString()} Files
    </td>
  );
}
